// extracted by mini-css-extract-plugin
module.exports = {"header":"SettingsListHeader_header__SMGbz"};